<template>
  <!--
      作者 gmshop
      时间：2020-06-09
      描述：会员-等级管理-添加等级
  -->
  <div class="product-add">
    <el-form size="small" :model="form" ref="form">
      <div class="common-form">商品信息</div>
      <el-button type="primary" size="small" icon="el-icon-plus" @click="changeProduct">选择商品</el-button>
      <el-form-item label="商品名称" v-if="form.product_id != 0">
        <p class="fb">{{ form.product_name }}</p>
      </el-form-item>
      <el-form-item label="商品图片" v-if="form.product_id != 0"><img :src="form.product_image" width="80" /></el-form-item>
      <!--选择商品-->
      <Product :isproduct="isproduct" :islist="false" @closeDialog="closeProductFunc"></Product>

      <div class="common-form">产品码信息</div>
      <el-form-item label="产品码数量" prop="code_num" :rules="[{required: true,message: '请输入产品码数量 '}]">
        <el-input v-model="form.code_num" class="max-w460" type="number"></el-input>
      </el-form-item>
      <el-form-item label="有效使用次数" prop="use_count" :rules="[{required: true,message: '请输入使用次数 '}]">
        <el-input v-model="form.use_count"  class="max-w460" type="number"></el-input>
        <div class="red">产品码有效使用次数，设置为0或者负数 不限制使用次数</div>
      </el-form-item>
      <el-form-item label="设备码" prop="machine_code" >
        <el-input v-model="form.machine_code"  class="max-w460" type="text"></el-input>
        <div class="red">设置后只有和设备码一直的设备才能使用该产品码，如果限制请留空</div>
      </el-form-item>
      <el-form-item label="使用时长 " prop="use_time" :rules="[{required: true,message: '请输入使用时长 '}]">
        <el-input v-model="form.use_time" min="1" class="max-w460" type="number">
          <template slot="append">分钟</template>
        </el-input>
        <div class="red">控制开机后的使用时长，可根据实际情况设置</div>
      </el-form-item>
      <el-form-item label="产品码前缀" prop="code_prefixes" :rules="[{required: true,message: '请输入产品码前缀 '}]">
        <el-input v-model="form.code_prefixes" class="max-w460"></el-input>
      </el-form-item>

    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
      <el-button size="small" type="primary" @click="add" :loading="loading">确认</el-button>
    </div>
    </el-form>
  </div>
</template>

<script>
import ProductApi from '@/api/product.js';
import Product from '@/components/product/Product.vue';
  export default {
    components: {
      /*选择商品*/
      Product
    },
    data() {
      return {
        form: {
          product_id: 0,
          product_name: '',
          use_count:1,
          use_time:'30',
          product_image: [],
          /*满值*/
          code_num: '',
          machine_code:'',
          code_prefixes: 'gm',
        },
        /*是否正在加载*/
        loading: false,
        /*是否打开选择商品*/
        isproduct: false,
      };
    },
    created() {

    },
    methods: {
      /*打开添加*/
      changeProduct() {
        this.isproduct = true;
      },

      /*关闭商品选择*/
      closeProductFunc(e) {
        let self = this;
        this.isproduct = false;
        if (e.type == 'success') {
          self.form.product_id = e.params.product_id;
          self.form.product_name = e.params.product_name;
          self.form.product_image = e.params.product_image;
        }
      },

      /*取消*/
      cancelFunc() {
        this.$router.back(-1);
      },

      /*添加*/
      add() {
        let self = this;
        let params = this.form;
        self.loading = true;
        ProductApi.addProductCode(params, true).then(data => {
            self.loading = false;
            self.$message({
              message: data.msg,
               type: 'success'
            });
            self.$router.push('/product/productcode/index');
          })
          .catch(error => {
            self.loading = false;
          });
      },


    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/product/productcode/add.vue